<ion-row class="etabFieldContainer" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">
  <div class="etabField" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">{{etablissement.name}}</div>
  <div class="etabField" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">{{etablissement.adresse}}</div>
  <div class="etabFieldLastPart" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">
    <div class="etabFieldSiret" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">{{etablissement.siret}}</div>
    <div class="etabFieldApe" [ngClass]="{'mobile': mediaQueryService.mobileQuery.matches}">{{etablissement.ape}}</div>
  </div>
</ion-row>
